module.exports = __webpack_public_path__ + "img/placemark.d60c1dbb.svg";